import React, {  useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { usunKatalog } from '../../../dao/Katalog';
import AlertErrorText from '../../../components/Alert/AlertErrorText';
import AlertSuccessText from '../../../components/Alert/AlertSuccessText';
export default function KatalogUsun(props) {
  const [open, setOpen] = useState(false);
  const [katalog, setKatalog] = useState(null);
  let biRefErrorInfo = {
  };
  let biRefSuccessInfo = {
  };
  const handleClickKDOpen = () => {
    setKatalog(props.biRef.getSelected());
    setOpen(true);
  };

  const handleUsun = () => {
      usunKatalogF();
  };
  

  async function usunKatalogF() {
    console.log(" usunKatalog id_kat " + katalog.id_kat);
   
    let x = await usunKatalog(katalog.id_kat).catch(e => {
      biRefErrorInfo.pokazText(e.message);
        return null;
    });
    console.log("usunKatalog " + (new Date()).toLocaleTimeString());
    if (!x) {
        console.log("błąd");
    } else {
      if(x.error)
      {
        biRefErrorInfo.pokazText(x.error.info);
        return;
      }
        biRefSuccessInfo.pokazText("usunięty");
        window.setTimeout(() => {
          setOpen(false);
          props.biRef.handleClose();
        }, 2000);
    }
};
  const handleClose = () => {
    setOpen(false);
  };
 
  return (
    <div>
         <Button variant="outlined" color="primary" onClick={handleClickKDOpen} style={{ textAlign: 'left' }}>
        Usuń katalog
      </Button>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Usun katalog</DialogTitle>
        <DialogContent>
        Usuń katalog: <strong>{(katalog) && katalog.nazwa}</strong>
          <br/>skrót: <strong>{(katalog) && katalog.id_kat}</strong>
          <AlertErrorText biRef={biRefErrorInfo} />
          <AlertSuccessText biRef={biRefSuccessInfo} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Anuluj
          </Button>
          <Button onClick={handleUsun} color="primary">
            Usuń
          </Button> 
        </DialogActions>
      </Dialog>
    </div>
  );
}